import React, {useEffect, useState} from "react";
import "../../../index.css";
import { useFormik } from 'formik';
import ConstantStatusString from "../../../util/constantStatusString";
import Constants from "../../../util/constantStrings";

function ServicesAdvanceSearch({searchParams, setSearchParams, onSearch, isCompleted}) {
    const [statusList, setStatusList] = useState([]);
    const userRole = JSON.parse(localStorage.getItem("user")).role;
    const formik = useFormik({
        initialValues: {
            Fmprotocol: "",
            assigneePlate: "",
            customerCarPlate: "",
            serviceStatus: "",
            date: "",
            Partner: ""
        },
        onSubmit: () => {
            onSearch(searchParams)
        },
        onReset: values => {
            const searchParams = {
                Fmprotocol: values.Fmprotocol,
                AssignPlate: values.assigneePlate,
                CustomerPlate: values.customerCarPlate,
                GeoStatusID: values.serviceStatus,
                Partner: values.partner
            }
            setSearchParams(searchParams)
            onSearch()
        }
    });
    useEffect(()=>{
        const statusArray = Array.from(ConstantStatusString.STATUS_STRING_MAP, ([value, text]) => ({ value, text }));
        const statusOptionArray = statusArray.filter(statusItem => isCompleted ? statusItem.value === Constants.SERVICE_GEO_STATUS_ID : statusItem.value !== Constants.SERVICE_GEO_STATUS_ID)
        setStatusList(statusOptionArray)
    },[])
  return (
   <div className="container advance-search-container">
      <form  onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <input
              id="Fmprotocol"
              name="Fmprotocol"
              type="number"
              placeholder="Dosya Numarası"
              className="advance-search-input"
              onChange={(event) => {
                  setSearchParams({
                      ...searchParams,
                      Fmprotocol: event.target.value
                  })
              }}
              value={searchParams?.Fmprotocol}
          />
          {userRole !== Constants.SUPERVISOR_ADMIN && <input
              id="assigneePlate"
              name="assigneePlate"
              type="text"
              className="advance-search-input"
              placeholder="Atanan Plaka"
              onChange={(event) => {
                  setSearchParams({
                      ...searchParams,
                      AssignPlate: event.target.value
                  })
              }}
              value={searchParams?.AssignPlate}
          />}
          {userRole === Constants.SUPERVISOR_ADMIN && <input
              id="partner"
              name="partner"
              type="text"
              className="advance-search-input"
              placeholder="Tedarikçi"
              onChange={(event) => {
                  setSearchParams({
                      ...searchParams,
                      Partner: event.target.value
                  })
              }}
              value={searchParams?.Partner}
          />}
          <input
              id="customerCarPlate"
              name="customerCarPlate"
              type="text"
              className="advance-search-input"
              placeholder="Sigortalı Plaka"
              onChange={(event) => {
                  setSearchParams({
                      ...searchParams,
                      CustomerPlate: event.target.value
                  })
              }}
              value={searchParams?.CustomerPlate}
          />
          <select
              id="serviceStatus"
              name="serviceStatus"
              className="advance-search-input"
              placeholder="Durum"
              onChange={(event) => {
                  setSearchParams({
                      ...searchParams,
                      GeoStatusID: parseInt(event.target.value)
                  })
              }}
              value={searchParams?.GeoStatusID}
          >
              <option value={""}>Servis Statüsü</option>
              {statusList.map(statusItem => {
                  return (
                      <option value={statusItem.value} key={statusItem.value}>{statusItem.text}</option>
                  )
              })}
          </select>
          <button className="advance-search-filter-button" type="submit">Ara</button>
          <button className="advance-search-reset-button" type="reset">Temizle</button>
      </form>
    </div>
  );
}

export default ServicesAdvanceSearch;
